import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.generalPanel.title',
    defaultMessage: 'GENERAL PANEL',
  },
  back: {
    id: 'reports.generalPanel.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'reports.generalPanel.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'reports.generalPanel.class',
    defaultMessage: 'Class',
  },
  chain: {
    id: 'reports.generalPanel.chain',
    defaultMessage: 'chain',
  },
  totalStudents: {
    id: 'reports.generalPanel.totalStudents',
    defaultMessage: 'Total students',
  },
  averageHits: {
    id: 'reports.generalPanel.averageHits',
    defaultMessage: 'Average hits',
  },
  averageErrors: {
    id: 'reports.generalPanel.averageErrors',
    defaultMessage: 'Average errors',
  },
  generalPerformance: {
    id: 'reports.generalPanel.generalPerformance',
    defaultMessage: 'Overall performance',
  },
  generalPerformanceByClass: {
    id: 'reports.generalPanel.generalPerformanceByClass',
    defaultMessage: 'Overall performance by series',
  },
  generalPerformanceByComponent: {
    id: 'reports.generalPanel.generalPerformanceByComponent',
    defaultMessage: 'Overall performance by curriculum component',
  },
  generatePdf: {
    id: 'reports.generalPanel.generatePdf',
    defaultMessage: 'Download PDF',
  },
  see: {
    id: 'reports.generalPanel.see',
    defaultMessage: 'See',
  },
  studentsRanking: {
    id: 'reports.generalPanel.studentsRanking',
    defaultMessage: 'Student ranking',
  },
  studentsAZ: {
    id: 'reports.generalPanel.studentsAZ',
    defaultMessage: 'Students',
  },
  hitPercentage: {
    id: 'reports.generalPanel.hitPercentage',
    defaultMessage: 'Percentage of correct answers',
  },
  schoolCriteria: {
    id: 'reports.generalPanel.schoolCriteria',
    defaultMessage: 'School criteria',
  },
  studentsGradeTitle: {
    id: 'reports.generalPanel.studentsGradeTitle',
    defaultMessage: 'Student grades table',
  },
  selectOptionAbove: {
    id: 'reports.generalPanel.selectOptionAbove',
    defaultMessage: 'Select an option above',
  },
  application: {
    id: 'reports.generalPanel.application',
    defaultMessage: 'Application',
  },
  evaluation: {
    id: 'reports.generalPanel.evaluation',
    defaultMessage: 'Evaluation',
  },
  level: {
    id: 'reports.generalPanel.level',
    defaultMessage: 'Level',
  },
  book: {
    id: 'reports.generalPanel.book',
    defaultMessage: 'Book',
  },
  generalPerformanceComparative: {
    id: 'reports.generalPanel.generalPerformanceComparative',
    defaultMessage: 'Overall performance – Comparison between notebooks',
  },
  generalPerformanceComparativeCurricularComponent: {
    id: 'reports.generalPanel.generalPerformanceComparativeCurricularComponent',
    defaultMessage: 'Overall performance - Comparison between curricular components',
  },
  hitPercentageBook1: {
    id: 'reports.generalPanel.hitPercentageBook1',
    defaultMessage: 'Percentage of correct answers - Book 1',
  },
  hitPercentageBook2: {
    id: 'reports.generalPanel.hitPercentageBook2',
    defaultMessage: 'Percentage of correct answers - Book 2',
  },
  comparativeSchoolCriteria: {
    id: 'reports.generalPanel.comparativeSchoolCriteria',
    defaultMessage: 'Comparative books - school criteria',
  },
});
